import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

export class FolderModel extends BaseObject {

    constructor() {
        super();
        this._created = null;
        this._created_by = null;
        this._fid= null;
        this._name= null;
        this._info = null;
        this._snapshots = [];
    }

    get snapshots() {return this._snapshots;}
    set snapshots(value) {this._snapshots = value;}

    get info() {return this._info;}
    set info(value) {this._info = value;}

    get name() {return this._name;}
    set name(value) {this._name = value;}

    get created_by() {return this._created_by;}
    set created_by(value) {this._created_by = value;}

    get created() {return this._created;}
    set created(value) {this._created = value;}

    get fid() {return this._fid;}
    set fid(value) {this._fid = value;}

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new FolderModel());
        } else if (target instanceof FolderModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(FolderModel, {
    _snapshots: alias("snapshots", list(Schema.primitive())),
    _info: alias("info", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _created_by: alias("created_by", Schema.primitive()),
    _created: alias("created", Schema.primitive()),
    _fid: alias("fid", Schema.primitive()),
});